//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      this_isLocation: false,
      geolocation: null, //定位实例
      locationMarker: null, //定位点
      options: { timeout: 8000 }
    };
  },
  props: {
    isLocation: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    scenicBound: {
      type: Array
    },
    mapObj: {
      type: Object
    },
    activeImg: {
      type: String
    },
    defaultImg: {
      type: String
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // 监听组件本地的展开收起状态 与父组件同步
    // this_isLocation(newV, oldV) {
    //   this.$emit("changeIsLocation", newV);
    // }
    isLocation(newV, oldV) {
      // console.log(newV + "----" + oldV);
      if (newV == true) {
        // 初始默认持续获取当前定位
        // this.watchCurPosition();
        this.geolocation.getLocation(
          this.showPosition,
          this.showErr,
          this.options
        );
      }
    }
  },
  //方法集合
  methods: {
    // 持续获取当前定位
    watchCurPosition() {
      console.log("持续定位开始");
      let that = this;
      that.geolocation.watchPosition(showPosition);
      function showPosition(position) {
        console.log(position);
        let lnglat = new AMap.LngLat(position.lng, position.lat);
        sessionStorage.setItem("lng", position.lng);
        sessionStorage.setItem("lat", position.lat);
        // console.log(lnglat);
        if (that.scenicBound.length > 0) {
          console.log("有电子围栏");
          if (that.isInBound(position.lat, position.lng, that.scenicBound)) {
            console.log("在电子围栏内");
          } else {
            console.log("不在电子围栏内");
            // $.toast("您当前不在景区范围内", "text");
            that.$vux.toast.text("您当前不在景区范围内", "bottom");
            return;
          }
        } else {
          console.log("没有电子围栏");
        }
        if (that.this_isLocation) {
          that.locationMarker.setPosition(lnglat);
        } else {
          that.this_isLocation = true;
          that.locationMarker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-8, -16),
            content: "<div class='curMarker'></div>",
            zIndex: 200
          });
          that.mapObj.add(that.locationMarker);
        }
      }
    },
    // 是否在一个电子围栏内
    isInBound(lat, lng, bound) {
      let polygon = new AMap.Polygon({
        map: this.mapObj,
        path: bound,
        strokeColor: "#fefefe", //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线宽
        fillColor: "#333", //填充色
        fillOpacity: 0 //填充透明度
      });
      this.mapObj.remove(polygon);
      // mapObj.add(polygon)
      if (polygon.contains(new AMap.LngLat(lng, lat))) {
        return true;
      } else {
        return false;
      }
    },
    // 移动到当前位置
    moveToCurPosition() {
      if (this.this_isLocation) {
        this.mapObj.setCenter([
          sessionStorage.getItem("lng"),
          sessionStorage.getItem("lat")
        ]);
      } else {
        this.geolocation.getLocation(
          this.showPosition,
          this.showErr,
          this.options
        );
      }
    },
    // 单次定位 获取定位成功事件
    showPosition(position) {
      console.log("首次定位成功");
      // this.$vux.toast.text("首次定位成功");
      console.log(position);
      sessionStorage.setItem("lng", position.lng);
      sessionStorage.setItem("lat", position.lat);
      // 获取定位成功后 准备开始持续定位
      // // 先判断是否要判断电子围栏
      // if (this.scenicBound) {
      //   console.log("有电子围栏");
      // } else {
      //   console.log("没有电子围栏");
      // }
      if (this.scenicBound.length > 0) {
        console.log("有电子围栏");
        if (this.isInBound(position.lat, position.lng, this.scenicBound)) {
          console.log("在电子围栏内");
        } else {
          console.log("不在电子围栏内");
          // $.toast("您当前不在景区范围内", "text");
          this.$vux.toast.text("您当前不在景区范围内", "bottom");
          return;
        }
      } else {
        console.log("没有电子围栏");
      }
      this.watchCurPosition();
    },
    // 单次定位 获取定位失败事件
    showErr() {
      console.log("首次定位失败");
      this.$vux.toast.text("获取定位失败", "bottom");
    },
    // 停止获取当前定位
    clearWatchCurPosition() {
      console.log("off");
      this.geolocation.clearWatch();
      if (this.locationMarker != null) {
        this.mapObj.remove(this.locationMarker);
        this.this_isLocation = false;
        this.locationMarker = null;
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.geolocation = new qq.maps.Geolocation(
      "3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM",
      "myweb"
    );
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    console.log("销毁定位监听");
    this.clearWatchCurPosition();
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/components/getLocation.vue